<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.records" @click="$var('accept', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-datepicker inline title="Дата поступления" v-bind="$form.input('publishedAt')" :text="!edit.records" />
      <n-input title="Номер вагона (автомашины)" v-bind="$form.input('carrNumber')" :text="!edit.records" />
      <n-input title="Поставщик" v-bind="$form.input('dealer')" :text="!edit.records" />
      <n-input title="Материал" :value="$form.get('materialTitle') + ', ' + $form.get('materialCount')" text />
      <block-materials :project-id="project.id" @change="change" />
      <n-input title="Сертификат качества (паспорт, сертификат и т.д.)" v-bind="$form.input('certificate')" :text="!edit.records" />
      <n-input title="Вид упаковки" v-bind="$form.input('type')" :text="!edit.records" />
      <n-input title="Масса, партия, номер" v-bind="$form.input('mass')" :text="!edit.records" />
      <n-datepicker inline title="Дата изготовления" v-bind="$form.input('manufactureDate')" :text="!edit.records" />
      <n-input title="Место отбора образца (выборки или пробы)" v-bind="$form.input('takePlace')" :text="!edit.records" />
      <n-datepicker inline title="Дата отбора образца (выборки или пробы)" v-bind="$form.input('takeDate')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    
    <c-modal-journal-do-sign v-if="$var('accept')" @close="$var('accept', false)" @submit="(s) => accept('records', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'
import BlockMaterials from '../../../records/create/MaterialBlock'

export default {
  name: 'ModalRecord',
  components: { BlockMaterials, CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
      material: null,
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status !== 'done' && $app.auth.can('journals_input_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.input.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    change({ id, count, title, }) {
      this.$form.set('materialId', id)
      this.$form.set('materialCount', count)
      this.$form.set('materialTitle', title)
    },
    save() {
      this.$var('load', true)
      $api.journals.input.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
